// 3rd Party
import _ from 'lodash';

// FutureLab
import { LoadUserProfilesDetailsTypes, LoadUserProfilesDetailsActions, UserDetailsListItem } from '../model/index';
import createReducer from './createReducer';

export const userListProfilesDetails = createReducer<UserDetailsListItem[]>([], {
	[LoadUserProfilesDetailsTypes.LOAD_USERS_PROFILES_DETAILS](
		state: UserDetailsListItem[],
		action: LoadUserProfilesDetailsActions
	) {
		const stateBackup = _.cloneDeep(state);
		const stateBackupMarged = _.merge(_.keyBy(stateBackup, 'id'), _.keyBy(action.payload, 'id'));
		state = _.values(stateBackupMarged);
		return state;
	},
});
